export default __webpack_public_path__ + "static/media/tehdas_loppukokoonpano_360.51e73d44.jpg";